import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import Animate from 'animate.css';
Vue.prototype.$axios = axios


Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueCookies)
Vue.use(Animate)
// Vue.directive('scroll', {
//   inserted: function (el, binding) {
//     const f = function (evt) {
//       if (binding.value(evt, el)) {
//         window.removeEventListener('scroll', f);
//       }
//     }
//     window.addEventListener('scroll', f);
//   }
// });
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
